import { ComponentProps, useCallback, useRef, useState } from "react";
import { Filter, FilterMode } from "@/shared/lib/filter/filter";
import { Input } from "@/shared/components/ui/input";

export function SearchFilter({
  filter,
  onFilterChange,
  ...props
}: {
  filter: Filter<string>;
  onFilterChange: (filter: Filter<string>) => void;
} & Omit<ComponentProps<"input">, "value" | "onChange">) {
  const [searchValue, setSearchValue] = useState(
    (filter.values && filter.values[0]) ?? "",
  );

  const debouncedOnFilterChange = useDebounce((value: string) => {
    if (value === "") {
      onFilterChange({ active: false, mode: FilterMode.Like, values: [] });
    } else {
      onFilterChange({ active: true, mode: FilterMode.Like, values: [value] });
    }
  });

  return (
    <Input
      value={searchValue}
      onChange={(e) => {
        setSearchValue(e.target.value);
        debouncedOnFilterChange(e.target.value);
      }}
      {...props}
    />
  );
}

function useDebounce<T extends (...args: never[]) => void>(fn: T, ms = 300) {
  const ref = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  return useCallback(
    (...args: Parameters<T>) => {
      clearTimeout(ref.current);
      ref.current = setTimeout(() => fn(...args), ms);
    },
    [fn, ms],
  ) as T;
}
